module.exports = __webpack_public_path__ + "static/img/page_23.f8609d71.png";